<!--The content below is only a placeholder and can be replaced.-->
<div class="pie" id="chart">
  <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart" [labels]="chartOptions.labels"
    [fill]="chartOptions.fill" [dataLabels]="chartOptions.dataLabels" [responsive]="chartOptions.responsive">
  </apx-chart>
</div>
